import blissImage from "../../../assets/svg_icons/bliss_face.svg";

const BlissAssistantCard = () => {
  return (
    <button type="button" className="marketplace-bliss-card" aria-label="Talk to Bliss">
      <div className="marketplace-bliss-avatar">
        <img src={blissImage} alt="" aria-hidden="true" />
      </div>
      <div className="marketplace-bliss-label">
        <strong>Talk to Bliss</strong>
        <span>Chats left 10/10</span>
      </div>
    </button>
  );
};

export default BlissAssistantCard;
